import React__default from 'react';
import { P2 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations.js';
import { formatMoney } from '../../../utils/utils.js';
import styles from './Savings.module.scss.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const SavingsAmount = (props) => {
    const locale = useSiteContext().locale;
    return (React__default.createElement("span", { className: styles.savingsWrapper },
        React__default.createElement(P2, { bold: true, className: `${styles.savingsAmount} ${props.extraSavingsAmountStyle || ''}` },
            "-",
            formatMoney(props.savedMoney, props.currency, locale))));
};
const Savings = (props) => {
    const { site } = useSiteContext();
    const { t } = useTranslation(site.realm);
    return (React__default.createElement("div", { className: styles.savings },
        t(props.interval == 1
            ? 'checkout.cart-offer.savings-info_one'
            : 'checkout.cart-offer.savings-info_other', { postProcess: 'interval', count: props.interval }),
        React__default.createElement(SavingsAmount, { savedMoney: props.savedMoney, currency: props.currency, extraSavingsAmountStyle: props.extraSavingsAmountStyle })));
};

export { Savings, SavingsAmount };
//# sourceMappingURL=Savings.js.map
